var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.card)?_c('i',{staticClass:"card-tag",class:['card-' + _vm.card.class]},[_vm._v(_vm._s(_vm.card.name))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }